import { graphql } from "@/lib/gql/__generated__";

export const HOTEL_APPLICATION_DATA_QUERY = graphql(/* GraphQL */ `
	query HotelApplicationDataQuery($hotelID: ID!) {
		hotelApplicationStatus(hotelID: $hotelID) {
			id
			hotelID
			onboardingVersion
			roomNum
			timezone
			currencyType
			hotelAccountType
			isPaymentFaild
			inUseBasic
			issuedBasicFreeTrialTicket
			validDtEndBasicInitialSetUp
			basicPlanWillBeExpired
			validDtEndBasic
			proTicketWillBeExpired
			validDtEndPro
			inSale
			isBankInfoRegistered
			isCreditCardRegistered
			isBillingPlanRegistered
			isHotelRegistered
			isHotelPolicyRegistered
			isRoomRegistered
			isPlanRegistered
			isOptionRegistered
			isSitecontrollerRegistered
			isPriceInserted
			isTestReservationAvailable
			isHostDirectReservationAvailable
		}
		billingStatus(hotelID: $hotelID) {
			id
			hotelID
			defaultBasicBillingTicketID
			defaultBasicBillingTicketName
			isStopRecurringBasicBilling
			currentBasicBillingTicketName
			validDtEndBasic
			nextBillingDtBasic
			defaultProBillingTicketID
			defaultProBillingTicketName
			isStopRecurringProBilling
			currentProBillingTicketName
			validDtEndPro
			nextBillingDtPro
		}
	}
`);
